@if(isOpenModal) {
    <div
    class="relative z-10"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="fixed inset-0 bg-black bg-opacity-75 transition-opacity wrapper-modal"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        class="flex min-h-full items-start justify-center p-4 text-center sm:p-0"
      >
        <div
          class="relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl"
          [ngClass]="{'modal__container--w-mobile': isMobile}"
        >
          <div class="bg-white pb-10 pt-5">
              <div class="flex justify-center pb-2.5">
                  @switch (templateModal) {
                      @case (templateModalEnum.SUCCESS) {
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0047BB" class="w-16 h-16">
                              <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                          </svg>
                      }
                      @case (templateModalEnum.WARNING) {
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FFB906" class="w-16 h-16">
                              <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
                          </svg>

                      }
                      @case (templateModalEnum.ERROR) {
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FE3824" class="w-16 h-16">
                              <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
                          </svg>
                      }
                  }
                  @if(showCloseModalButton){
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 absolute md:left-[90%] left-[85%] cursor-pointer" (click)="closeModal()">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  }

              </div>
              <div class="flex justify-center px-10 sm:px-16">
                <div class="mt-3 text-center sm:mx-4 sm:mt-0">
                  <ng-content select="[body]"></ng-content>
                </div>
              </div>
          </div>
          <div class="bg-gray-50 px-4 pb-3 sm:flex sm:flex-row-reverse sm:px-6 justify-center">
              <ng-content select="[footer]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
}
